// extracted by css-extract-rspack-plugin
export default {"filtersContainer":"filters-container--sZaVp6BoegLJWfzk"};